<template>
    <div class="sidebar-container">
        <div class="product-sidebar">
            <div class="btn-group-product-control sidebar-buttons"
                :class="{'delete-disabled': (!$parent.permissionAllowed('delete_products') || $parent.product.info.parentProduct.id !== null)}"
                role="group"
                aria-label="Update, Delete, Clone product"
            >
                <button type="button" v-on:click="uiStates.showCloneProduct = !uiStates.showCloneProduct" class="btn btn-info">
                    <span v-if="uiStates.showCloneProduct">Cancel</span>
                    <span v-else>Clone</span>
                </button>
                <transition name="fade" v-if="$parent.permissionAllowed('manage_products')">
                    <button type="button" v-on:click="productEnableDisable(0)" v-if="product.info.enabled" class="btn btn-primary btn-product-enabler">
                        Published
                    </button>
                    <button type="button" v-on:click="productEnableDisable(1)" v-else class="btn btn-warning btn-product-enabler">
                        Unpublished
                    </button>
                </transition>
                <div v-if="$parent.permissionAllowed('delete_products')">
                    <transition v-bind:name="confirmDelete.transitionValue">
                        <div v-if="confirmDelete.isActive == true" class="btn-group btn-confirm-delete">
                            <button type="button" class="btn btn-danger" href="#" v-on:click.prevent="productDelete()">
                                <span>Confirm</span>
                            </button>
                            <button type="button" class="btn btn-outline-danger" v-on:click="cancelDeletion()">
                                <i class="fa fa-times" aria-hidden="true"></i>
                            </button>
                        </div>
                        <button style="border-left: none !important;"
                            class="btn btn-danger btn-start-confirmation w-100"
                            @click="confirmDeletion()"
                            v-if="confirmDelete.isActive == false">
                            <span>Delete</span>
                        </button>
                    </transition>
                </div>
            </div>
            <transition name="expand">
                <div class="clone-product-container"  v-if="uiStates.showImportProduct">
                    <div class="placard clone-product-form">
                        <div class="sidebar-item-body">
                            <div class="form-group">
                                <select-item-from-api-provided-list
                                    class="pt-2"
                                    api="pimapi/products"
                                    :columns="['name']"
                                    list-label="Select Product"
                                    @selection="selectImportProduct"
                                    apiType="meta"
                                    :small="true"
                                >
                                </select-item-from-api-provided-list>
                            </div>
                            <div class="form-group clone-product-options">
                                <div>
                                    <input type="checkbox" id="general" value="general" v-model="importProduct.importData">
                                    <label for="general">General</label>
                                </div>
                                <div>
                                    <input type="checkbox" id="categories" value="categories" v-model="importProduct.importData">
                                    <label for="categories">Categories</label>
                                </div>
                                <div>
                                    <input type="checkbox" id="attributes" value="attributes" v-model="importProduct.importData">
                                    <label for="attributes">Attributes</label>
                                </div>
                                <div>
                                    <input type="checkbox" id="assets" value="assets" v-model="importProduct.importData">
                                    <label for="assets">Assets</label>
                                </div>
                                <div>
                                    <input type="checkbox" id="pricing" value="pricing" v-model="importProduct.importData">
                                    <label for="pricing">Pricing</label>
                                </div>
                                <div>
                                    <input type="checkbox" id="inventory" value="inventory" v-model="importProduct.importData">
                                    <label for="inventory">Inventory</label>
                                </div>
                                <div>
                                    <input type="checkbox" id="relations" value="relations" v-model="importProduct.importData">
                                    <label for="relations">Relations</label>
                                </div>
                                <div>
                                    <input type="checkbox" id="channels" value="channels" v-model="importProduct.importData">
                                    <label for="channels">Channels</label>
                                </div>
                                <div>
                                    <input type="checkbox" id="concrete_entities" value="concrete_entities" v-model="importProduct.importData">
                                    <label for="concrete_entities">Entities</label>
                                </div>
                            </div>
                            <div class="form-group submit-clone">
                                <button v-if="$parent.permissionAllowed('clone_product')" v-on:click="importProductData()" :disabled="importProduct.value == null" type="button" class="btn btn-primary">Import from Product</button>
                            </div>
                        </div>
                    </div>
                </div>
            </transition>
            <transition name="expand">
                <div class="clone-product-container"  v-if="uiStates.showCloneProduct">
                    <div class="placard clone-product-form">
                        <div class="sidebar-item-body">
                            <div class="form-group">
                                <label for="">
                                    <span class="label-title">{{cloneProduct.label}}</span>
                                    <span v-if="cloneProduct.required" class="required-field">*</span>
                                </label>
                                <input-text v-model="cloneProduct.value" :field-data="cloneProduct"></input-text>
                            </div>
                            <div class="form-group clone-product-options">
                                <div>
                                    <input type="checkbox" id="general" value="general" v-model="cloneProduct.clonables">
                                    <label for="general">General</label>
                                </div>
                                <div>
                                    <input type="checkbox" id="categories" value="categories" v-model="cloneProduct.clonables">
                                    <label for="categories">Categories</label>
                                </div>
                                <div>
                                    <input type="checkbox" id="attributes" value="attributes" v-model="cloneProduct.clonables">
                                    <label for="attributes">Attributes</label>
                                </div>
                                <div>
                                    <input type="checkbox" id="assets" value="assets" v-model="cloneProduct.clonables">
                                    <label for="assets">Assets</label>
                                </div>
                                <div>
                                    <input type="checkbox" id="pricing" value="pricing" v-model="cloneProduct.clonables">
                                    <label for="pricing">Pricing</label>
                                </div>
                                <div>
                                    <input type="checkbox" id="inventory" value="inventory" v-model="cloneProduct.clonables">
                                    <label for="inventory">Inventory</label>
                                </div>
                                <div>
                                    <input type="checkbox" id="relations" value="relations" v-model="cloneProduct.clonables">
                                    <label for="relations">Relations</label>
                                </div>
                                <div>
                                    <input type="checkbox" id="concrete_entities" value="concrete_entities" v-model="cloneProduct.clonables">
                                    <label for="concrete_entities">Entities</label>
                                </div>
                            </div>
                            <div class="form-group submit-clone">
                                <button v-if="$parent.permissionAllowed('clone_product')" v-on:click="createClone()" :disabled="cloneProduct.value === ''" type="button" class="btn btn-primary">Create Clone</button>
                            </div>
                        </div>
                    </div>
                </div>
            </transition>
        </div>

        <div class="placard" v-if="$parent.product.info.parentProduct.id !== null">
            <div class="sidebar-item parent-info">
                <div class="sidebar-item-heading">
                    <span class="title">Parent Product Details</span>
                    <a class="link-to-product" :href="'/products/'+$parent.product.info.parentProduct.id+'/edit'">View</a>
                </div>
                <div class="sidebar-item-body parent-info-panel">
                    <div>
                        <div class="product-preview-heading product-preview-parent">
                            <div class="product-details-thumbnail bg-pos-center" :style="{ backgroundImage: 'url(' + $parent.product.info.parentProduct.thumbnail + ')' }" v-if="$parent.product.info.parentProduct.thumbnail">
                            </div>
                            <div class="copy" :class="{'with-image' : $parent.product.info.parentProduct.thumbnail}">
                                <a class="title" v-if="$parent.product.info.parentProduct.id !== null" :href="'/products/'+$parent.product.info.parentProduct.id+'/edit'">{{$parent.product.info.parentProduct.name}}</a>
                                <div class="sku" v-if="$parent.product.info.parentProduct.sku !== null">Sku: {{$parent.product.info.parentProduct.sku}}</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="sidebar-item-body sidebar-item-no-pad">
                    <div v-if="$parent.product.info && $parent.product.info.optionValues !== null">
                         <div class="" v-if="$parent.product.info.optionValues.length > 0">
                             <table class="table table-minimal">
                                 <!-- <tr>
                                     <th colspan="2">Child Options</th>
                                 </tr> -->
                                 <tr v-for="optionValue in product.info.optionValues">
                                     <td class="w-50">{{optionValue.optionName}}</td>
                                     <td class="w-50 text-right">{{optionValue.optionValueLabel}}</td>
                                 </tr>
                             </table>
                          <!--    <ul class="parent-options">
                                 <li v-for="optionValue in product.info.optionValues"> <strong>{{optionValue.optionName}}</strong> : {{optionValue.optionValueLabel}}</li>
                             </ul> -->
                         </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="placard">
           <!--  <div class="product-status-container clearfix">
                <div class="product-readiness-status">
                    <ul>
                        <li :class="{ enabled: product.readiness.content_status }"><i class="fa fa-file-text-o" aria-hidden="true"></i></li>
                        <li :class="{ enabled: product.readiness.categorization_status }"><i class="fa fa-sitemap" aria-hidden="true"></i></li>
                        <li :class="{ enabled: product.readiness.photo_status }"><i class="fa fa-picture-o" aria-hidden="true"></i></li>
                        <li :class="{ enabled: product.readiness.pricing_status }"><i class="fa fa-usd" aria-hidden="true"></i></li>
                    </ul>
                </div>
                <div class="btn-group-toggle product-enabler" data-toggle="buttons">
                    <transition name="fade">
                        <button type="button" v-on:click="productEnableDisable(0)" v-if="product.info.enabled" class="btn btn-primary active btn-product-enabler"> Published</button>
                        <button type="button" v-on:click="productEnableDisable(1)" v-else class="btn btn-danger active btn-product-enabler"> Unpublished</button>
                    </transition>
                </div>
            </div> -->
            <!-- <sidebar-value-group
                :grouping-route="'/pimapi/products/'+ $parent.product.info.id+'/categories/'"
                :grouping-get-route="'/pimapi/categories'"
                :grouping-items-route="'/pimapi/products/'+ $parent.product.info.id+'/categories'"
                :grouping-name="'Categories'"
                :product-details="this.product"
                grouping-name-for-load="categories"
                :allow-multiple="true"
                require-delete-confirmation="true"
                confirmation-message="Removing a product from a category could have ramifications on the sync, are you sure you want to proceed?"
            ></sidebar-value-group> -->
            <sidebar-value-group
                :grouping-route="'/pimapi/products/'+ $parent.product.info.id+'/attribute_sets/'"
                :grouping-get-route="'/pimapi/attribute_sets'"
                :grouping-items-route="'/pimapi/products/'+ $parent.product.info.id+'/attribute_sets'"
                :grouping-name="'Attribute Sets'"
                :product-details="this.product"
                grouping-name-for-load="attribute_sets"
                :allow-multiple="true"
                require-delete-confirmation="false"
                confirmation-message=""
            ></sidebar-value-group>
            <sidebar-value-group
                :grouping-route="'/pimapi/products/'+ $parent.product.info.id+'/attributes/'"
                :grouping-get-route="'/userinterface/attributes'"
                :grouping-items-route="'/pimapi/products/'+ $parent.product.info.id+'/attributes'"
                :grouping-name="'Attributes'"
                :product-details="this.product"
                grouping-name-for-load="attributes"
                :allow-multiple="true"
                require-delete-confirmation="false"
                confirmation-message=""
            ></sidebar-value-group>
            <sidebar-value-group
                v-if="product.info.parentProduct.id === null"
                :grouping-route="'/pimapi/products/'+ $parent.product.info.id+'/option_set/'"
                :grouping-get-route="'/pimapi/option_sets'"
                :grouping-items-route="'/pimapi/products/'+ $parent.product.info.id+'/option_set'"
                :grouping-name="'Option Set'"
                :product-details="this.product"
                :allow-multiple="false"
                grouping-name-for-load="option_set"
                require-delete-confirmation="false"
                confirmation-message=""
            ></sidebar-value-group>
            <sidebar-tag-group
                v-if="false"
                :grouping-name="'Tags'"
                :product-details="this.product"
                grouping-name-for-load="tags"
            ></sidebar-tag-group>
        </div>
         <div v-if="$parent.featureAllowed('product_relations')" class="placard">
             <div class="sidebar-item sidebar-relations" :class="{active: uiStates.addProductRelation}">
                 <div class="sidebar-item-heading" :class="{'no-border' : Object.keys(productRelations.relations).length === 0}">
                    <transition name="vue-table-loader">
                        <div class="vue-table-loader alt" v-if="uiStates.showLoading"><span class="fa fa-cog fa-spin fa-1x"></span></div>
                    </transition>
                     <span class="title">Relations</span>
                     <a v-on:click.prevent="addRelation()" href="#" v-if="!uiStates.addProductRelation && $parent.permissionAllowed('product_relations')" class="action-trigger">Add Relation</a>
                     <a v-on:click.prevent="uiStates.addProductRelation = false" v-if="uiStates.addProductRelation" href="#" class="action-trigger">Cancel</a>
                 </div>
                 <div class="sidebar-relations-add">
                     <div class="form-group">
                         <label for="">Relation Type</label>
                         <select2 v-model="productRelationListing.selected.type"  class="attribute_select" :config="{placeholder: '', width: '100%'}">
                            <option value="">Choose..</option>
                            <option v-for="(type, index) in productRelationListing.relationTypes" :value="index">{{ type }}</option>
                         </select2>
                     </div>
                     <div class="form-group">
                        <label for="">Product</label>
                        <select-item-from-api-provided-list
                            class="pt-2"
                            api="pimapi/products"
                            :columns="['name']"
                            list-label="Select Product"
                            @selection="selectRelationProduct"
                            apiType="meta"
                            :small="true"
                        />
                     </div>
                     <div class="form-group">
                         <a v-on:click.prevent="postRelation(productRelationListing.selected)" href="#" class="btn btn-primary">Save Relation</a>
                     </div>
                 </div>
                 <div class="sidebar-item-body" v-if="Object.keys(productRelations.relations).length > 0">
                    <div v-for="(value, key) in productRelations.relations">
                        <div class="sidebar-relations-heading">
                            {{key}}
                        </div>
                        <ul class="sidebar-relations-listing">
                            <li v-for="product in value">
                                <a :href="'/products/'+product.id+'/edit/v2'">{{product.name.substring(0, 35)}}</a>
                                <div class="product-preview">
                                    <div class="product-preview-heading">
                                        <div class="product-details-thumbnail bg-pos-center" v-if="product.thumbnail">
                                            <img :src="product.thumbnail" alt="">
                                        </div>
                                        <div class="copy" :class="{'with-image' : product.thumbnail}">
                                            <div class="title">{{product.name}}</div>
                                            <div class="sku">Sku: {{product.sku}}</div>
                                        </div>
                                        <a class="link-to-product" :href="'/products/'+product.id+'/edit/v2'"><i class="fa fa-external-link" aria-hidden="true"></i></a>
                                        <a v-on:click.prevent="deleteRelation(product.id, product.type_id)" class="delete-relation" href="" aria-hidden="true"><i class="fa fa-trash" aria-hidden="true"></i></a>
                                    </div>
                                    <!-- @TODO: Add in price for each relation. -->
                                    <!-- <div class="product-preview-body">
                                        <div class="sidebar-pricing-listing">
                                            <div class="clearfix channel-item">
                                                <div class="channel-name">BigCommerce - Sales Sourcing</div>
                                                <div class="price">192.15</div>
                                            </div>
                                            <div class="clearfix channel-item">
                                                <div class="channel-name">BigCommerce - Customer Storefront</div>
                                                <div class="price">181.23</div>
                                            </div>
                                            <div class="clearfix channel-item">
                                                <div class="channel-name">Qlik - Business Intelligence</div>
                                                <div class="price">187.75</div>
                                            </div>
                                        </div>
                                    </div> -->
                                </div>
                            </li>
                        </ul>
                    </div>
                 </div>
             </div>
         </div>
         <div class="placard">
            <sidebar-pricing :product-pricing="this.pricesCondensed"
            v-if="$parent.permissionAllowed('manage_pricing')"
            ></sidebar-pricing>
         </div>
    </div>
</template>

<script type="text/javascript">
    var base_url = window.location.protocol + "//" + window.location.host

    import Vue from 'vue';
    import VueEvents from 'vue-events'
    import axios from 'axios'
    import select2 from 'select2';

    import InputText from '../form/form-text.vue';
    import SidebarValueGroup from './sidebar/sidebar-value-group.vue';
    import SidebarTagGroup from './sidebar/sidebar-tag-group.vue';
    import SidebarPricing from './sidebar/sidebar-pricing.vue';
    import SelectItemFromApiProvidedList from "../generic/select-item-from-api-provided-list.vue";
    import _ from 'lodash';

    Vue.use(VueEvents)

    export default {
        name: 'product-sidebar',
        props: ['productDetails', 'workflowSteps'],
        components:{
            'sidebar-value-group': SidebarValueGroup,
            'sidebar-tag-group': SidebarTagGroup,
            'sidebar-pricing': SidebarPricing,
            'input-text': InputText,
            'select-item-from-api-provided-list': SelectItemFromApiProvidedList
        },
        data() {
            return {
                uiStates: {
                    addProductRelation: false,
                    showLoading: false,
                    showCloneProduct: false,
                    showImportProduct: false
                },
                hasLoaded: {
                    categories: false,
                    attribute_sets: false,
                    attributes: false,
                    option_set: false,
                    tags: false
                },
                confirmDelete:{
                    transitionValue: 'slide',
                    isActive: false,
                },
                product: this.productDetails,
                selectedWorkflow: '',
                categories: [],
                attributes: [],
                optionSet: [],
                attributeSets: [],
                tags: [
                    {
                        id: 1,
                        tag_value_en: 'Testing Tag',
                    }
                ],
                productRelations: {
                    relations: {},
                },
                productRelationListing: {
                    products: [],
                    relationTypes: [],
                    selected: {
                        type: null,
                        product: null,
                    },
                },
                pricesCondensed: [],
                importProduct: {
                    value: null,
                    importData: [
                        "general",
                        "categories",
                        "attributes",
                        "assets",
                        "pricing",
                        "inventory",
                        "relations",
                        "channels",
                        "concrete_entities"
                    ],
                },
                cloneProduct: {
                    name: "name",
                    label: "Cloned Product Name",
                    required: false,
                    type: "text",
                    column: "col-md-6",
                    value: 'Copy of ' + this.productDetails.info.name,
                    clonables: [
                        "general",
                        "categories",
                        "attributes",
                        "assets",
                        "pricing",
                        "inventory",
                        "relations",
                        "concrete_entities"
                    ],
                }
            }
        },
        mounted() {
            this.loadProductRelations();
            this.loadProductPricing();
        },
        created() {
        },
        watch: {
        },
        methods: {
            selectRelationProduct(product) {
                this.productRelationListing.selected.product = product;
            },
            sidebarUpdateRelations(){
                this.$parent.$children.forEach(function(el, i){
                    if(el.$vnode.tag === 'vue-component-22-product-relations'){
                        el.loadAllRelations();
                    }
                });
            },
            selectImportProduct(item) {
                this.importProduct.value = item;
            },
            importProductData() {
                axios.post(base_url+ '/pimapi/products/'+this.$parent.product.info.id + '/import', {
                    'importFromID': this.importProduct.value.id,
                    'clonables': this.importProduct.importData,
                })
                .then(function (response) {
                    window.location.replace(base_url + '/products/' + response.data.payload + '/edit/v2');
                }.bind(this))
                .catch(function (error) {
                    this.uiStates.errorMessage = 'An error has occured!';
                }.bind(this));
            },
            updateAll() {
                axios.post(base_url+ '/pimapi/products/'+this.$parent.product.info.id+'/update-all', {
                    'languageId': this.$parent.languages.active,
                    'generalDetails': this.$parent.generalDetails,
                    'productSeo': this.$parent.productSeo,
                    'productMarketing' : this.$parent.productMarketing,
                    'productShipping': this.$parent.productShipping,
                    'filteredDisplayGroupId': this.$parent.filteredDisplayGroupId,
                    'productAttributes': this.$parent.productAttributes,
                })
                .then(function (response) {
                    this.$parent.alert.status = "alert-success";
                    this.$parent.alert.message = "Product successfully saved";
                    this.uiStates.showLoading = false;
                }.bind(this))
                .catch(function (error) {
                    this.$parent.alert.status = "alert-danger";
                    this.$parent.alert.message = "An Error Occured";
                    this.uiStates.showLoading = false;
                    this.uiStates.errorMessage = 'An error has occurred!';
                }.bind(this));
            },
            addRelation: function () {
                this.uiStates.showLoading = true;

                if (this.productRelationListing.products.length === 0) {
                    axios.get(base_url+ '/pimapi/products/relation-types')
                    .then(function (response) {
                        this.productRelationListing.relationTypes = response.data.payload.relationTypes;
                        this.uiStates.addProductRelation = true;
                        this.uiStates.showLoading = false;
                    }.bind(this))
                    .catch(function (error) {
                        this.uiStates.showLoading = false;
                        this.uiStates.errorMessage = 'An error has occurred!';
                    }.bind(this));
                }else{
                    this.uiStates.addProductRelation = true;
                    this.uiStates.showLoading = false;
                }
            },
            postRelation: function (criteria) {
                this.uiStates.showLoading = true;
                axios.post(base_url+ '/pimapi/products/'+this.$parent.product.info.id + '/relation/' + this.productRelationListing.selected.product.id + '/type/' + this.productRelationListing.selected.type)
                .then(function (response) {
                    this.loadProductRelations()
                    this.sidebarUpdateRelations()
                    this.uiStates.addProductRelation = false;
                    this.uiStates.showLoading = false;
                }.bind(this))
                .catch(function (error) {
                    this.uiStates.showLoading = false;
                    this.uiStates.errorMessage = 'An error has occurred!';
                }.bind(this));
            },
            deleteRelation: function (relationId, typeId) {
                this.uiStates.showLoading = true;
                axios.delete(base_url+ '/pimapi/products/'+this.$parent.product.info.id + '/relation/' + relationId + '/type/' + typeId, {
                    // 'criteria': criteria,
                })
                .then(function (response) {
                    this.loadProductRelations()
                    this.uiStates.showLoading = false;
                }.bind(this))
                .catch(function (error) {
                    this.uiStates.showLoading = false;
                    this.uiStates.errorMessage = 'An error has occurred!';
                }.bind(this));
            },
            loadProductRelations: function () {
                // if (!this.$parent.permissionAllowed('product_relations')) {
                //     return;
                // }
                 axios.get(base_url+ '/pimapi/products/'+this.$parent.product.info.id+'/relations', {
                    // 'criteria': criteria,
                })
                .then(function (response) {
                    this.productRelations = response.data.payload;
                }.bind(this))
                .catch(function (error) {
                    this.uiStates.errorMessage = 'An error has occurred!';
                }.bind(this));
            },
            loadProductPricing: function () {
                 axios.get(base_url+ '/pimapi/products/'+this.$parent.product.info.id+'/prices_by_channels/3', {
                    // 'criteria': criteria,
                })
                .then(function (response) {
                    this.pricesCondensed = response.data;
                }.bind(this))
                .catch(function (error) {
                    this.uiStates.errorMessage = 'An error has occurred!';
                }.bind(this));
            },
            createClone: function (criteria) {
                axios.post(base_url+ '/pimapi/products/'+this.$parent.product.info.id + '/clone', {
                    'name': this.cloneProduct.value,
                    'clonables': this.cloneProduct.clonables,
                })
                .then(function (response) {
                    window.location.replace(base_url + '/products/' + response.data.payload + '/edit/v2');
                }.bind(this))
                .catch(function (error) {
                    this.uiStates.errorMessage = 'An error has occurred!';
                }.bind(this));
            },
            productEnableDisable: function (criteria) {
                if (!this.$parent.permissionAllowed('manage_products')) {
                    return;
                }
                this.product.info.enabled = criteria

                axios.patch(base_url+ '/pimapi/products/'+this.$parent.product.info.id + '/enable', {
                    'enabled': criteria,
                })
                .then(function (response) {
                    this.$parent.alert.status = "alert-success";
                    if (this.product.info.enabled) {
                        this.$parent.alert.message = "Product changed to published";
                    }else{
                        this.$parent.alert.message = "Product changed to unpublished";
                    }
                }.bind(this))
                .catch(function (error) {
                    this.uiStates.errorMessage = 'An error has occurred!';
                }.bind(this));
            },
            productDelete: function (criteria) {
                axios.delete(base_url+ '/pimapi/products/'+this.$parent.product.info.id + '/delete', {
                    // 'enabled': criteria,
                })
                .then(function (response) {
                    window.location.replace(base_url + '/products');
                }.bind(this))
                .catch(function (error) {
                    this.uiStates.errorMessage = 'An error has occurred!';
                }.bind(this));
            },
            confirmDeletion () {
                if (this.$parent.product.info.parentProduct.id != null) {
                    alert('Child products have to be removed from the parent before being deleted.');
                    return false;
                }

                if (this.confirmDelete.isActive == true) {
                    this.cancelDeletion()
                }else{
                    this.confirmDelete.isActive = true;
                    this.confirmDelete.transitionValue = 'slide-reverse'
                }
            },
            cancelDeletion () {
                this.confirmDelete.isActive = false;
                this.confirmDelete.transitionValue = 'slide'
            },
            setPanel(page){
                this.$parent.setPanel(page);
            },
            saveWorkflowStep: function (selectedWorkflow) {
                if (selectedWorkflow == '') {
                    selectedWorkflow = null;
                }
                this.$parent.uiStates.showWorkflowLoading = true;
                axios.post(base_url+ '/pimapi/products/'+this.$parent.product.info.id+'/workflow', {
                    'workflowId': this.selectedWorkflow,
                })
                .then(function (response) {
                    // this.$parent.alert.status = "alert-success";
                    // this.$parent.alert.message = "Workflow step updated";
                    this.$parent.loadWorkflowSteps();
                }.bind(this))
                .catch(function (error) {
                    this.$parent.alert.status = "alert-danger";
                    this.$parent.alert.message = error.response.data.message;
                    this.$parent.uiStates.showWorkflowLoading = false;
                }.bind(this));
            }
        }
    };
</script>

<style scoped lang="scss">
    .sidebar-buttons {
        display: flex;
        flex-direction: column;
        gap: 0.175rem;

        & > button,
        & > div {
            width: 100%;
        }
    }
    .modal-dialog {
        top: 200px;
    }
    .expand-enter-active,
    .expand-leave-active {
      transition: all 0.2s;
      max-height: 145px;
      margin-bottom: 15px;
    }
    .expand-enter,
    .expand-leave-to
    {
      opacity: 0;
      max-height: 0px;
      margin-bottom: 0;
    }

    .fade-enter-active, .fade-leave-active {
      transition: opacity .2s;
    }
    .fade-enter, .fade-leave-to {
      opacity: 0;
    }

    .vue-table-loader{
        padding-top: 0;
        text-align: right;
        right: -11px;
        background-color: transparent;
    }
    .sidebar-relations .sidebar-item-heading{
        position: relative;
    }
    .delete-relation{
        color: #AB5755 !important;
        position: absolute;
        right: 10px;
        font-size: 14px !important;
        top: 24px;
    }

    .clone-product-container{
        position: relative;
        margin-bottom: 15px;
        &:before{
            position: absolute;
            top: -13px;
            left: calc(50% - 1px);
            content: "";
            width: 2px;
            height: 15px;
            border-left: 2px dotted #9e9e9e;
            z-index: -1;
        }
    }
    .clone-product-form{
        padding: 10px 15px;
        overflow: hidden;
        margin-bottom: 0;
        .form-group{
            margin-bottom: 15px;
        }
    }
    .submit-clone{
        margin-bottom:5px !important;
        .btn{
            width: 100%;
        }
    }
    .clone-product-options{
        display: grid;
        grid-template-columns: 1fr 1fr;
    }
    .product-enabler{
        .btn{
            padding: 10px 5px;
        }
    }


    .btn-confirm-delete{
        .btn{
            padding: 11px 8px 9px 8px;
            &:last-child{
                z-index: 10;
                // border-left:1px solid #ff9a9a;
            }
        }
    }
    .btn-start-confirmation{
        width: 100%;
    }
    .btn-confirm-delete {
        width: 100%;
        .btn{
            width: 100%;
        }
    }
    .btn-outline-danger{
        border-color: #AB5755;
        color:#AB5755;

    }
    .action-container{
        position: relative;
        border-left: 1px solid #f5f6fa;
        overflow: hidden;
        height: 38px;
        width: 33.33%;
        background-color: #AB5755;
        border-radius: 2px;
        .btn-confirm-delete, .btn-start-confirmation{
            position: absolute;
            width: 100%;
            top: 0;
        }
    }
    .slide-reverse-leave-active,
    .slide-reverse-enter-active,
    .slide-leave-active,
    .slide-enter-active {
      transition: 0.4s;
    }
    .slide-enter {
      transform: translate(-100%, 0);
      span{
        transition: opacity 0.4s;
        opacity: 1;
      }
    }
    .slide-leave-to {
        span{
            transition: opacity 0.4s;
            opacity: 0;
        }
      transform: translate(100%, 0);
    }

    .slide-reverse-enter {
      transform: translate(100%, 0);
      span{
        transition: opacity 0.4s;
        opacity: 1;
      }
    }
    .slide-reverse-leave-to {
        span{
            transition: opacity 0.4s;
            opacity: 0;
        }
      transform: translate(-100%, 0);
    }
    .btn-product-enabler{
        padding-left: 0 !important;
        padding-right: 0 !important;
    }
    .sidebar-workflow-manager{
        height: 39px;
        overflow: hidden;
    }
    .product-readiness-status{
        height: 38px;
    }

    .parent-info{
        .id-container{
            font-size: 10px;
            margin-bottom: 5px;
        }
        .parent-options{
            padding-left: 15px;
            list-style-type: none;
        }
        .sidebar-item-heading{
            position: relative;
            .link-to-product{
                position: absolute;
                right: 15px;
                top: 12px;
                color: #3191FF !important;
                font-size: 11px;
            }
        }
    }
    .product-preview-parent{
        position: relative;
        min-height: 45px;
        // margin-bottom: 10px;
        .copy{
            .title{
                font-size: 14px;
            }
            padding-top: 4px;
        }
        .product-details-thumbnail{
            width: 45px;
            height: 45px;
        }
    }
    .parent-info-panel{
        border-bottom: 1px solid #dedede;
    }
    .sidebar-item-no-pad{
        padding:0;
        .table-minimal{
            margin-bottom:0;
            tr{
                th{
                    color: #576670;
                    font-size: 11px;
                    border-top: 0px;
                    padding: 5px 20px;
                }
                td{
                    font-size: 10px;
                    padding: 5px 20px;
                }
                &:first-child{
                    td{
                        border-top: 0px;
                    }
                }
                &:last-child{
                    td{
                        border-bottom: 0px;
                    }
                }
            }
        }
    }
</style>
